import { QuestionForm } from '@/features/questions-page/Form/ui/Form.jsx'
import './ui/Form.scss'
export default QuestionForm
